// extracted by mini-css-extract-plugin
export default {"btn":"LPButton_btn__biIMX","lineButton":"LPButton_lineButton__hi5hQ"};